import { SELECTORS } from "@Redux";
import { LISTING_MISCELLANEOUS_DATA_TYPES } from "@Utils";
import React from "react";
import { useSelector } from "react-redux";

const useCourseDetail = ({
    courseDetail,
}: {
    courseDetail: {
        value: number;
        key: string;
        title: string;
    };
}) => {
    const event = useSelector(SELECTORS.event);

    const [data, setData] = React.useState<Array<string> | undefined>([]);

    React.useEffect(() => {
        setData(
            courseDetail.key === LISTING_MISCELLANEOUS_DATA_TYPES.highlights.key
                ? event?.miscellaneousData.highlights
                : event?.miscellaneousData.requirements
        );
    }, [event.miscellaneousData]);

    return {
        data,
    };
};

export default useCourseDetail;
